import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Message } from 'primereact/message';
import { Tag } from 'primereact/tag';

const MpesaLogs = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    // Placeholder for M-Pesa specific logs
    // This would connect to a payment/M-Pesa specific endpoint

    const statusTemplate = (rowData) => {
        const severity = rowData.status === 'Success' ? 'success' : 'danger';
        return <Tag value={rowData.status} severity={severity} />;
    };

    return (
        <div className="mpesa-logs">
            <Message
                severity="info"
                text="M-Pesa Transaction Logs - This section will display logs specific to M-Pesa payment transactions and events."
            />

            <DataTable
                value={logs}
                loading={loading}
                emptyMessage="No M-Pesa transaction logs found"
                className="mt-3"
            >
                <Column field="timestamp" header="Timestamp" />
                <Column field="transactionId" header="Transaction ID" />
                <Column field="phoneNumber" header="Phone Number" />
                <Column field="amount" header="Amount" />
                <Column field="status" header="Status" body={statusTemplate} />
                <Column field="reference" header="Reference" />
            </DataTable>
        </div>
    );
};

export default MpesaLogs;